<template>
<div>
    <section class="page-title">
    <div class="center servidor">
        <p class="label-planos">Servidor Público</p>
        <h1 class="the-title"><span>Soluções</span> para Servidor</h1>
        <p>O sorriso do Servidor Público faz parte dos nossos Planos!</p>
        <a @click="scrollToClass('.contrataragora')" class="button-contrate">Contratar Agora</a>
    </div>
</section>
<section class="page-content center">
    <p class="title-label">A PrimaVida</p>
    <p>A PrimaVida Dental é formada por uma diretoria composta por dentistas e especialistas em gestão odontológica, com mais 45 anos de experiência.</p>
    <p>Desenvolveu mecanismos de utilização, eliminando burocracia, de forma a proporcionar agilidade nos atendimentos, com fácil comunicação, mediante alto nível de informatização em seus processos, com utilização de tecnologia de ponta.</p>
    <p>Ampla e completa rede referenciada que atende a todas as especialidades e está distribuída por pontos estratégicos em todo o território nacional.</p>
    <p>Realiza palestras sobre prevenção e saúde oral, com a aplicação de flúor, inclusive em projetos sociais com comunidades carentes.</p>
    <p class="title-label">Por que comprar um plano PrimaVida?</p>
    <p>A Primavida tem planos atrativos, flexíveis e acessíveis para você e sua família, confira:</p>
    <p style="margin-bottom: 0px;"><strong>Agilidade</strong> - kit de Adesão (Carteirinha virtual e Rede credenciada na palma de sua mão em até 24 horas úteis após a aceitação da sua Proposta Comercial.)
    Autorização de tratamentos totalmente on-line.</p>
    <p><strong>Referência em qualidade</strong> - Vencedora de dois Oscar do Seguro, 2012/2013 e 2017/2018, pelo Reconhecimento do CVG/RJ (Clube Vida em Grupo). <img src="../Content/images/oscar.png" width="20px"></p>
    <p><strong>Ampla elegibilidade</strong> - Adesão extensiva ao grupo familiar.</p>
    <p><strong>Atendimento personalizado</strong> - WhatsApp, diariamente, 24 (vinte e quatro) horas, Site, área restrita ao beneficiário e Call Center.</p>
    <p><strong>Rede Credenciada</strong> - Ampla rede credenciada com mais de 10.000 dentistas em todo o Brasil, Acesso diário aos dentistas credenciados 24 horas com o conforto e a comodidade do smartphone, Possibilidade de indicar o seu dentista para credenciamento, Rede exclusiva no Estado do Rio de Janeiro.</p>
    <p><strong>Desconto em Farmácia</strong> - Através da rede de drogarias credenciadas,<img src="../Content/images/raia.jpg" width="60px"> &nbsp; <img src="../Content/images/drogasil.jpg" width="110px">  , os beneficiários PrimaVida Dental receberão descontos em vários medicamentos, e ainda descontos em produtos de higiene, entre outras.</p>
    <p class="title-label">Quem pode aderir?</p>
    <p style="margin-bottom: 10px;">O plano ofertado é Individual/Familiar, podendo ser adquirido por Servidor Público, mediante consulta de averbação em condições especiais, sendo extensivo a seus dependentes:</p>
    <p style="margin-bottom: 5px;"><strong>Pai / Padrasto</strong></p>
    <p style="margin-bottom: 5px;"><strong>Mãe / Madrasta</strong></p>
    <p style="margin-bottom: 5px;"><strong>Filhos / Enteados</strong></p>
    <p style="margin-bottom: 5px;"><strong>Cônjuge / Companheiro</strong></p>
    <p>Entende-se como Plano Individual a adesão de apenas 01 Titular e para o Plano Familiar a adesão de 01 titular e no mínimo 01 dependente.</p>
    <p class="title-label">Condições especiais para Servidor Público</p>
    <p>Servidor Público com autorização do órgão averbador para desconto em folha de pagamento, receberá um desconto vitalício na mensalidade, <a @click="scrollbotton()" class="button-contrate">Contratar Agora</a></p>
    <p class="title-label">Principais Coberturas</p>
    <div class="icone consultas">
        <span class="icon"></span>
        <p><strong>Consultas</strong> - Consultas iniciais para o plano de tratamento;</p>
    </div>
    <div class="icone urgencia">
        <span class="icon"></span>
        <p><strong>Urgência</strong> - Diversos procedimentos de urgência odontológica;</p>
    </div>
    <div class="icone cirurgia">
        <span class="icon"></span>
        <p><strong>Cirurgia</strong> - Cirurgias odontológicas de pequeno porte realizada em consultórios;</p>
    </div>
    <div class="icone dentistica">
        <span class="icon"></span>
        <p><strong>Dentística</strong> - Restaurações e obturações em material estético (Resina) e amálgama;</p>
    </div>
    <div class="icone endodontia">
        <span class="icon"></span>
        <p><strong>Endodontia</strong> - Tratamento de canais;</p>
    </div>
    <div class="icone periodontia">
        <span class="icon"></span>
        <p><strong>Periodontia</strong> - Tratamento de gengivas;</p>
    </div>
    <div class="icone odontopediatria">
        <span class="icon"></span>
        <p><strong>Odontopediatria</strong> - Atendimento especializado para crianças;</p>
    </div>
    <div class="icone radiologia">
        <span class="icon"></span>
        <p><strong>Radiologia</strong> - Periapical, interproximal (bite-wing), oclusal, periapical completa (levantamento radiográfico);</p>
    </div>
    <div class="icone protese">
        <span class="icon"></span>
        <p><strong>Próteses</strong> - Coroa provisória, Restauração, Coroa, Núcleo e Bloco metálico para dentes permanentes posteriores, Coroa em Cerômero para dentes permanentes anteriores (Entende-se como dentes permanentes anteriores, os dentes definitivos da frente, que correspondem do canino a canino);</p>
    </div>
    <div class="icone profilaxia">
        <span class="icon"></span>
        <p><strong>Prevenção</strong> - Profilaxia / Aplicação de Flúor;</p>
    </div>
    <div class="icone exodontia">
        <span class="icon"></span>
        <p><strong>Exodontia</strong> - Extração, inclusive de siso incluso;</p>
    </div>
    <div>
        <p>Para acessar a cobertura do Rol da ANS, <a href="http://www.primavida.com.br/emkt/rol_procedimentos.pdf" target="_blank">clique aqui.</a></p>
    </div>
    <p class="title-label">Representante Autorizado RJ</p>
        <li class="textoRep">Av. Rio Branco,123 - Salas 2106 a 2111</li>
        <li class="textoRep">Centro - Rio de Janeiro RJ CEP 20040-905</li>
        <li class="textoRep">Tel. (21) 3299.4500</li>
    <br>
    <p class="title-label">Carências</p>
    <p>Carência é o prazo ininterrupto, em que o beneficiário não goza do direito de utilizar da cobertura do plano contratado, sendo este prazo contado da data de averbação para desconto em folha de pagamento junto ao seu órgão, que será entendida como data de início de vigência do beneficiário.</p>
    <table class="table-carencia" cellpadding="0" cellspacing="0" border="0">
        <tr>
            <th></th>
            <th colspan="1">Carências</th>
        </tr>
        <tr class="mini-header">
            <td>Procedimentos</td>
            <td class="carencia">Plano Individual/Familiar</td>
        </tr>
        <tr>
            <td>Consulta de Urgência</td>
            <td class="carencia">24 horas</td>
        </tr>
        <tr>
            <td>Consulta inicial, Radiologia, Prevenção</td>
            <td class="carencia">24 horas</td>
        </tr>
        <tr>
            <td>Odontopediatria, Periodontia, Dentística, Cirurgia Oral Menor</td>
            <td class="carencia">24 horas</td>
        </tr>
        <tr>
            <td>Endodontia</td>
            <td class="carencia">120 dias</td>
        </tr>
        <tr>
            <td>Prótese</td>
            <td class="carencia">180 dias</td>
        </tr>
    </table>
    <div class="contrataragora">
     <v-fade-transition mode="out-in">
    <div class="exibelocalizacao" v-if="exibeLocalizacao">
    <div class="planos-wrapper">
    <p class="planos-title">Orgão Averbador</p>
    <v-layout align-center>
    <v-flex xs12 sm12>
        <v-card
            flat
            max-height="400px"
            max-width="600px"
            class="mx-auto localizacao"
            style="border: 1px solid; border-color: #009b9b;border-radius: 10px;">
            <v-card-text>
                <v-container grid-list-md>
                <v-layout align-center justify-center row wrap>
                <v-flex xs12 sm12 lg10>
                <v-select
                id="comboOrgao"
                v-model="idOrgao"
                item-value="id"
                item-text="orgao"
                :items="orgaosAverbadores"
                label="Orgão Averbador"
                ></v-select>
                </v-flex>
                <v-layout align-center justify-center row wrap>
                <v-flex xs12 sm6 md6 lg6 >
                <v-btn
                style="border-radius: 6px;"
                large
                dark
                @click="controlaExibicaoPlanos()"
                color="#009b9b"
                >Consultar Planos</v-btn>
                </v-flex>
                </v-layout>
                </v-layout>
                </v-container>
            </v-card-text>
        </v-card>
    </v-flex>
    </v-layout>
    </div>
    </div>
    <div class="exibeplanos" v-else>
    <p class="title-label">Investimento</p>
    <p>O investimento abaixo no plano odontológico é valor unitário da mensalidade que o Responsável Financeiro paga para a operadora.</p>
    <div class="planos-wrapper">
    <p class="planos-title">Orgão Averbador:  {{this.nomeOrgao}}
        <v-btn
        icon
        dark
        @click.prevent="exibeLocalizacao = !exibeLocalizacao"
        color="#009b9b"
        >
        <v-icon style="margin-right: 0%;">cached</v-icon>
        </v-btn>
        </p>
        <!-- <p class="planos-title">INDIVIDUAL ANUAL</p> -->
        <v-container
            grid-list-md
            >
        <v-layout row wrap justify-center>
                <v-flex
                v-for="plano in planos" :key="`3${plano.id}`" xs12 sm12 md12 lg4
                >
                <div class="list-planos">
                    <div class="item">
                        <h6 class="dePara">De</h6>
                        <p class="priceOld"><span>R$</span> {{plano.oldValue}}<br></p>
                        <h6 class="dePara">Por</h6>
                        <p class="price"><span>R$</span> {{plano.value}}<br><span>(Por pessoa)</span></p>
                        <h6 class="desconto">Desconto especial de R$ {{calculaDesconto(plano)}}</h6>
                                <p class="cobertura"><span>{{plano.area_atuacao}}</span><b>{{plano.qualificacao}}</b></p>
                        <div class="boleto"><i class="fas fa-barcode"></i>{{plano.name}}</div>
                        <a @click="contratoSP(plano)" class="button">Contratar plano</a>
                    </div>
                </div>
                </v-flex>
            </v-layout>
        </v-container>
    </div>
    </div>
    </v-fade-transition>
</div>
</section>
<v-dialog v-model="dialog" max-width="700px" max-height="400px">
      <v-card>
          <v-container grid-list-md>
            <v-layout row wrap justify-center>
              <v-card-title>
              <span class="total">Prezado(a) cliente,</span>
              </v-card-title>
              <v-container
                    fluid
                    pa-1
                    justify-center
                    class="resumo"
                  >
              <p class="resumo" >Valorizamos a privacidade de seus dados. Por isso, investimos em modernidade nos nossos canais de comunicação, garantindo assim a  segurança e a tranquilidade que você precisa.</p>
              <p class="resumo" >Por esse motivo, estamos enviando um termo de privacidade sobre os seus dados cadastrais.</p>
              <p class="resumo" >É necessário que você acesse nossa política de privacidade e aceite os termos para continuarmos recebendo e enviando suas informações.</p>
              <br>
              <p class="resumo" style="font-weight: bold">A <span style="color:#009B99">PrimaVida Dental</span> agradece a sua atenção !</p>
              <p class="resumo" style="font-weight: bold">Vindo de você, tudo é importante!!!</p>
              <br>
              <p class="resumo" style="font-weight: bold;color:#009B99">Termo de Privacidade, <a href="https://ecommerce.primavida.com.br/contratosprimavida/docs/Politica_de_Privacidade_PrimaVida_LGPD.pdf" target="_blank">clique aqui.</a></p>

              <v-checkbox
                    v-model="contrataccept"
                    color="#009B99"
                >
                <span slot="label">Estou ciente e concordo com o Termo de Privacidade da PrimaVida Dental.</span>
          </v-checkbox>
              </v-container>
            </v-layout>
            <v-card-actions>
              <v-container
                    fill-height
                    fluid
                    pa-1
                    justify-center
                  >
                  <br>
              <v-btn @click="confirmaPlano()" color="#009b9b" depressed style="border-radius: 8px; width: 130px;color: white;">Continuar</v-btn>
              </v-container>
            </v-card-actions>
          </v-container>
      </v-card>
    </v-dialog>
<Snackbar ref=chamaSnackbar />
</div>
</template>

<script>
import Snackbar from '../components/snackbar.vue'
import axios from 'axios'
import { baseApiUrl } from '@/global'
export default {
    components: {Snackbar},
data(){
        return{
            desconto: '',
            idOrgao: '',
            abrangenciaOrgao: '',
            abrangenciaId: '',
            nomeOrgao: '',
            exibeLocalizacao: true,
            planos: [],
            vendedor: [],
            planoSelecionado: [],
            orgaosAverbadores: [],
            contrataccept: false,
            dialog: false,
    };
  },
  /* watch: {
    'estado': function () {
      this.cidades = brasil[this.estado].cidades
    }
  }, */
    mounted : function(){
      localStorage.clear()
      sessionStorage.clear()
      this.pegaParametrosUrl()
      this.$store.dispatch('ExibeToolbar')
      this.exibeLocalizacao = true;
      this.$store.dispatch('Logar')
      this.carregaOrgaos()
    },
    methods: {
        scrollToClass(className) {
            // Get the first element with the given class name
            let el = this.$el.querySelector(className)
            // Get the bounding rectangle so we can get the element position position
            let rect = el.getBoundingClientRect()
            // Scroll to the element (using x and y axis)
            window.scrollTo(rect.left, rect.top)
            },
        scrollbotton(){
            window.scrollTo(0, 3000)
        },

    async carregaOrgaos(){
        this.idOrgao = ''
        await axios.get(`${baseApiUrl}OrgaoAverbadors?filter[where][status]=Ativo`).then(res => {
            if(res.data != null){
            for(var i=0; i<res.data.length; i++) {
                    if(res.data[i].orgaoexibicao.includes("RJ"))
                        this.orgaosAverbadores.push(res.data[i])
                    }
                }
        })

    },

        async controlaExibicaoPlanos(){
            if((this.idOrgao == ''))
            {
              var vm = this;
              vm.$refs.chamaSnackbar.snack("#0288D1","Selecione o Orgão Averbador","INFOMRÇÃO")
            }
            else{
                for(var i=0; i<this.orgaosAverbadores.length; i++) {
                    if(this.orgaosAverbadores[i].id === this.idOrgao) {
                        this.nomeOrgao = this.orgaosAverbadores[i].orgao
                        this.abrangenciaOrgao = this.orgaosAverbadores[i].abrangenciaId
                        this.abrangenciaId = this.orgaosAverbadores[i].id
                    }
                }
            await axios.get(`${baseApiUrl}Plans?filter={"where":{"and":[{"abrangenciaId":{"inq":["${this.abrangenciaOrgao}"]}},{"qualificacao":{"inq":["Individual","Familiar"]}},{"publico":"Servidor"}]}}`).then(res => {
              if (res.data !== null) {
                // Check if `this.vendedor` is defined and store the id
                const vendedorId = this.vendedor ? this.vendedor.id: 0;

                // Filter exclusive plans based on vendedor
                const exclusivePlans = res.data.filter(plan =>
                    plan.isExclusive && vendedorId !== undefined &&
                    plan.salesmans.includes(vendedorId)
                );

                // If there are no exclusive plans, filter non-exclusive plans
                this.planos = exclusivePlans.length > 0 ? exclusivePlans : res.data.filter(item => !item.isExclusive);

                console.info(this.planos);
              }
			})
            this.exibeLocalizacao = false;
            }


        },
        confirmaPlano(){
            if(this.contrataccept)
            {
                localStorage.clear()
                sessionStorage.clear()
                this.$store.dispatch('planosSP', this.planoSelecionado)
                sessionStorage.setItem('orgaoAverbadorId',this.abrangenciaId)
                localStorage.setItem('planoSelecionado',JSON.stringify(this.planoSelecionado))
                if(this.vendedor !== '')
                   sessionStorage.setItem('Vendedor',JSON.stringify(this.vendedor))

                let router = this.planoSelecionado.id === "66c4a0bb5a2725597b0a576b" ? "/prefeitura_sp" : "/contratosp"
                this.$router.push({ path: router})
            }
             else
            {
               var vm = this;
              vm.$refs.chamaSnackbar.snack("#F9A825","Para continuar, é necessário concordar com os termos de privacidade!","ATENÇÃO")
            }
        },
        contratoSP(plano){
            this.dialog = true
            this.planoSelecionado = plano
        },
        calculaDesconto(plano){
            var desconto = parseFloat(plano.oldValue.replace(',', '.')) - parseFloat(plano.value.replace(',', '.'))
            //desconto = desconto.replace('.','.')
            return desconto.toFixed(2).replace('.',',')
        },
        async pegaParametrosUrl(){
            var params = window.location.search.substring(1).split('&');
            if(params[0] != ''){
            //Criar objeto que vai conter os parametros
            var paramArray = {};

            //Passar por todos os parametros
            for(var i=0; i<params.length; i++) {
                //Dividir os parametros chave e valor
                var param = params[i].split('=');

                //Adicionar ao objeto criado antes
                paramArray[param[0]] = param[1];
                }
            if(paramArray['vendedor'])
            {
            await axios.get(`${baseApiUrl}Salesmans?filter[where][linkSite]=${paramArray['vendedor'].toLowerCase()}`).then(res => {
                    if(res.data != null){
                    //console.log(res.data[0])
                    this.vendedor = res.data[0]
                    }
                    })
                }
            }
            }
    }
}
</script>

<style>
    .localizacao{
        border: 1px solid;
        border-color: #009b9b;
    }
.planos-wrapper .list-planos .item .priceOld {
    margin-bottom: -10px;
    font-weight: 700;
    font-size: 30px;
    line-height: 34px;
    color: #009b9b;
    text-align: center;
    text-decoration: line-through;
}
.planos-wrapper .list-planos .item .priceOld span {
    margin-bottom: -10px;
    font-size: 15px;
    font-weight: 300;
    color: #666;
    position: relative;
    top: -15px;
    margin-right: -5px;
}

.dePara{
    margin-bottom: -10px;
    font-weight: 400;
    font-size: 15px;
    line-height: 37px;
    color: #009b9b;
    text-align: center;
}
.planos-wrapper .list-planos .item .price {
    margin-bottom: -5px;
    font-weight: 700;
    font-size: 45px;
    line-height: 37px;
    color: #009b9b;
    text-align: center;
}
.desconto{
    text-align: center;
    margin-bottom: 5px;
    font-size: 15px;
    font-weight: 300;
    color: #666;
    position: relative;
    top: -15px;
    margin-right: -10px;
}

</style>
